"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var StringManipulater_1 = require("Utils/StringManipulater");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var ProjectDeleter = (function () {
    function ProjectDeleter(projectStatusChecker, projectCounter, projectLiveCounter, projectApiService, projectTemplater, modal) {
        var _this = this;
        this.projectStatusChecker = projectStatusChecker;
        this.projectCounter = projectCounter;
        this.projectLiveCounter = projectLiveCounter;
        this.projectApiService = projectApiService;
        this.projectTemplater = projectTemplater;
        this.modal = modal;
        this.delete = function (projects) { return __awaiter(_this, void 0, Promise, function () {
            var areDeletableResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lodash_1.default.isArray(projects)) {
                            projects = [projects];
                        }
                        if (projects.length === 0) {
                            return [2, {
                                    success: false,
                                    message: "Not given any projects to delete.",
                                }];
                        }
                        areDeletableResult = this.areDeletable(projects);
                        if (!areDeletableResult.success) {
                            return [2, areDeletableResult];
                        }
                        return [4, this.doDeletion(projects)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.confirmDelete = function (projects) { return __awaiter(_this, void 0, Promise, function () {
            var modalArgs;
            return __generator(this, function (_a) {
                if (!lodash_1.default.isArray(projects)) {
                    projects = [projects];
                }
                modalArgs = {
                    title: this.getConfirmationTitle(projects),
                    explainer: this.getConfirmationExplanation(projects),
                    confirmLabel: this.getConfirmationButtonLabel(projects),
                };
                if (this.getNumberOfLivePages(projects) > 0) {
                    modalArgs.explainer = "Please note that you have selected a live Qwilr page. ".concat(modalArgs.explainer);
                }
                return [2, this.modal.showDeleteModal(modalArgs)];
            });
        }); };
    }
    ProjectDeleter.prototype.doDeletion = function (projects) {
        return __awaiter(this, void 0, Promise, function () {
            var projectIds, deletionResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        projectIds = lodash_1.default.map(projects, function (project) { return project._id; });
                        deletionResult = {
                            success: true,
                            message: "",
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.projectApiService.deleteProjects(projectIds)];
                    case 2:
                        _a.sent();
                        this.removeTemplates(projects);
                        this.projectCounter.remove(this.getNumberOfPages(projects));
                        this.projectLiveCounter.remove(this.getNumberOfLivePages(projects));
                        deletionResult.message = this.getDeletedSuccessMessage(projects);
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        deletionResult.success = false;
                        deletionResult.message = this.getDeletedErrorMessage(projects);
                        return [3, 4];
                    case 4: return [2, deletionResult];
                }
            });
        });
    };
    ProjectDeleter.prototype.areDeletable = function (projects) {
        var e_1, _a;
        try {
            for (var projects_1 = __values(projects), projects_1_1 = projects_1.next(); !projects_1_1.done; projects_1_1 = projects_1.next()) {
                var project = projects_1_1.value;
                var result = this.isDeletable(project);
                if (!result.success) {
                    return result;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (projects_1_1 && !projects_1_1.done && (_a = projects_1.return)) _a.call(projects_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return {
            success: true,
            message: "",
        };
    };
    ProjectDeleter.prototype.isDeletable = function (project) {
        if (project.hasTemplateChildren) {
            return {
                success: false,
                message: "Cannot delete a template containing children or with archived children.",
            };
        }
        else if (!this.projectStatusChecker.isDeletable(project)) {
            var message = "Cannot delete this Qwilr page.";
            if (project.status === Types_1.ProjectStatus.Accepted) {
                message = "Cannot delete an accepted Qwilr page.";
            }
            else if (this.projectStatusChecker.isPartiallyAccepted(project)) {
                message = "Cannot delete a partially accepted Qwilr page.";
            }
            return {
                success: false,
                message: message,
            };
        }
        else {
            return {
                success: true,
                message: "",
            };
        }
    };
    ProjectDeleter.prototype.removeTemplates = function (projects) {
        var _this = this;
        projects
            .filter(function (project) { return _this.projectTemplater.isTemplate(project); })
            .forEach(function (project) { return _this.projectTemplater.removeFromTemplateLibrary(project); });
    };
    ProjectDeleter.prototype.getNumberOfPages = function (projects) {
        var _this = this;
        return projects.filter(function (project) { return !_this.projectTemplater.isTemplate(project); }).length;
    };
    ProjectDeleter.prototype.getNumberOfTemplates = function (projects) {
        var _this = this;
        return projects.filter(function (project) { return _this.projectTemplater.isTemplate(project); }).length;
    };
    ProjectDeleter.prototype.getNumberOfLivePages = function (projects) {
        var _this = this;
        return projects.filter(function (project) { return !_this.projectTemplater.isTemplate(project) && project.status == Types_1.ProjectStatus.Live; }).length;
    };
    ProjectDeleter.prototype.getConfirmationTitle = function (projects) {
        var numberOfTemplates = this.getNumberOfTemplates(projects);
        var numberOfPages = this.getNumberOfPages(projects);
        if (numberOfTemplates === 0) {
            return numberOfPages === 1 ? "Delete this Qwilr page?" : "Delete ".concat(numberOfPages, " Qwilr pages?");
        }
        else if (numberOfPages === 0) {
            return numberOfTemplates === 1 ? "Delete this template?" : "Delete ".concat(numberOfTemplates, " templates?");
        }
        else {
            return "Delete ".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " and ").concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), "?");
        }
    };
    ProjectDeleter.prototype.getConfirmationExplanation = function (projects) {
        var numberOfTemplates = this.getNumberOfTemplates(projects);
        var numberOfPages = this.getNumberOfPages(projects);
        if (numberOfTemplates === 0) {
            return numberOfPages === 1
                ? "Deleting this Qwilr page will mean it can't be edited, shared, or viewed online anymore. Are you sure you want to delete \"".concat(projects[0].name, "\"?")
                : "Deleting these Qwilr pages will mean they can't be edited, shared, or viewed online anymore. Are you sure you want to delete them?";
        }
        else if (numberOfPages === 0) {
            return numberOfTemplates === 1
                ? "This will not affect pages you have created using this template. Are you sure you want to delete \"".concat(projects[0].name, "\"?")
                : "This will not affect pages you have created using this template. Are you sure you want to delete them?";
        }
        else {
            return "Deleting these Qwilr pages and templates will mean they can't be edited, shared, or viewed online anymore. Are you sure you want to delete them?";
        }
    };
    ProjectDeleter.prototype.getConfirmationButtonLabel = function (projects) {
        var numberOfTemplates = this.getNumberOfTemplates(projects);
        var numberOfPages = this.getNumberOfPages(projects);
        if (numberOfTemplates === 0) {
            return numberOfPages === 1 ? "Delete page" : "Delete ".concat(numberOfPages, " pages");
        }
        else if (numberOfPages === 0) {
            return numberOfTemplates === 1 ? "Delete template" : "Delete ".concat(numberOfTemplates, " templates");
        }
        else {
            return "Delete";
        }
    };
    ProjectDeleter.prototype.getDeletedSuccessMessage = function (projects) {
        var numberOfTemplates = this.getNumberOfTemplates(projects);
        var numberOfPages = this.getNumberOfPages(projects);
        if (numberOfTemplates === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " deleted.");
        }
        else if (numberOfPages === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " deleted.");
        }
        else {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " and ").concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " deleted.");
        }
    };
    ProjectDeleter.prototype.getDeletedErrorMessage = function (projects) {
        var numberOfTemplates = this.getNumberOfTemplates(projects);
        var numberOfPages = this.getNumberOfPages(projects);
        if (numberOfTemplates === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " can't be deleted.");
        }
        else if (numberOfPages === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " can't be deleted.");
        }
        else {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " and ").concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " can't be deleted.");
        }
    };
    return ProjectDeleter;
}());
exports.default = ProjectDeleter;
